import { Link } from "react-router-dom";
import { all_routes } from "../../../router/all_routes";

const CBTFacts = () => {

    const CBTBenefits = [
        "Pilihan Uji Kompetensi Sistem CBT Beragam",
        "Investasi Terjangkau",
        "Tampilan & Navigasi CBT Lengkap",
        "Disertai Pembahasan per Soal",
        "Skor Akhir, Benar/Salah",
        "Dapat Sertifikat Pengakuan Kelulusan",
        "Akses Soal Semuanya",
    ];


    return (<>
        <div className="py-5">
            <div className="container">
                <div className="row">
                    <div className="col-md-7">
                        <div className="px-5">
                            <img src="/assets/img/testimonial/cbt.webp" className="img-fluid" alt="Course" />
                        </div>
                    </div>

                    <div className="col-md-5 d-flex align-items-center">
                        <div>
                            <h4 className="fw-bold my-4 text-primary">
                                Uji Kompetensi Sistem CBT <br />
                                Program
                            </h4>

                            <p className="fw-medium mb-2" style={{ fontSize: '18px', color: '#1E344C' }}>
                                Buktikan Pemahamanmu dengan Uji Kompetensi
                                Sistem (Computer Based Test) CBT yang Handal
                                dan Soal yang Beragam!
                            </p>

                            {CBTBenefits.map((text, index) => (
                                <p key={index} className="d-flex align-items-center justify-content-start mb-0">
                                    <img src="/assets/icon/check-primary.png" alt="check" className="me-2 mt-1" style={{ maxWidth: 'none', height: '34px' }} />

                                    <span className="fw-medium" style={{ fontSize: '18px', color: '#1E344C' }}>{text}</span>
                                </p>
                            ))}

                            <Link to={all_routes.jadiUkom} className="btn btn-yellow mt-3" style={{ padding: '10px 20px' }}>
                                <span className="fw-bold text-dark" style={{ fontSize: '18px' }}>Kerjakan Sekarang</span>
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </>);
}

export default CBTFacts;